import React from "react";
import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";
import {
  Box, Grid, Stack, Container, Skeleton
} from "@mui/material";
import FinanceSupportForm from "./FinanceSupportForm";
import { getFinanceSupportPage } from "../../services/FinanceSupportPageService";
import HeroSection from "../../components/common/HeroSection";

const FinanceSupport = () => {
  const { country_id, country_name } = useSelector((state) => state.auth || {});
  
  const { data: financeData, isLoading: loading } = useQuery({
    queryKey: ["financeSupportPage", country_id],
    queryFn: async () => {
      if (!country_id) return null;
      const res = await getFinanceSupportPage(country_id);
      if (res?.data?.success && res?.data?.data) {
        return res.data.data;
      }
      return null;
    },
    enabled: !!country_id,
  });

  if (loading) {
    return (
      <Container
        sx={{
          py: { xs: 3, sm: 4, md: 6 },
          px: { xs: 3, sm: 4, md: 6 },
        }}
      >
        <Grid container spacing={2} alignItems="center">
          <Grid size={{ xs: 12, md: 6 }}>
            <Skeleton variant="text" height={60} width="80%" />
            <Skeleton variant="text" height={30} width="90%" />
            <Skeleton variant="text" height={30} width="85%" />
            <Stack direction="row" spacing={2} mt={3}>
              <Skeleton variant="rounded" width={140} height={45} />
              <Skeleton variant="rounded" width={140} height={45} />
            </Stack>
            <Stack spacing={2} mt={3}>
              <Skeleton variant="text" width="70%" />
              <Skeleton variant="text" width="60%" />
              <Skeleton variant="text" width="75%" />
            </Stack>
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <Skeleton variant="rectangular" height={420} sx={{ borderRadius: 2 }} />
          </Grid>
        </Grid>
      </Container>
    );
  }

  if (!financeData)
    return (
      <Box sx={{ textAlign: "center", mt: 10 }}>
        <p>No financial support data found for {country_name || "selected country"}.</p>
      </Box>
    );

  const heroTitle = financeData.hero_section_title || "";
  const heroSubtitle = financeData.hero_section_desc || "";
  const heroImage = financeData.hero_section_image || "";
  const heroImageType = financeData.hero_section_image_type || "image";

  return (
    <>
      <HeroSection
        titleContent={heroTitle}
        subtitleContent={heroSubtitle}
        heroImage={heroImage}
        heroImageType={heroImageType}
      />
      <FinanceSupportForm />
    </>
  );
};

export default FinanceSupport;
